
const DsfGwHomeHeader = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_home_gw_template" */ "./homeHeader"));
export { DsfGwHomeHeader };
export default {
  install(Vue) {
    Vue.component("DsfGwHomeHeader", DsfGwHomeHeader);
  }
};
